module.exports = __webpack_public_path__ + "img/paragraph.7732fceb.svg";